// cloudinary.js
import { Cloudinary } from '@cloudinary/url-gen';

const cld = new Cloudinary({ 
    cloud: {
        cloudName: 'dglbwcbch',
    }
});

export default cld;
